export default __webpack_public_path__ + "static/media/marketing_analytics_img.32770519.png";